// analytics.js — CampusReveal event tracking utility
// Wraps window.gtag safely so it never throws if GA hasn't loaded yet.

const GA_ID = process.env.REACT_APP_GA_ID; // set in client/.env

/* ── Page view ── */
export function trackPageView(path) {
  if (!window.gtag || !GA_ID) return;
  window.gtag('config', GA_ID, { page_path: path });
}

/* ── Generic event ── */
export function trackEvent(eventName, params = {}) {
  if (!window.gtag) return;
  window.gtag('event', eventName, params);
}

// ─── Convenience wrappers ──────────────────────────────────────
// Call these from your components so tracking is centralised here.

/** User viewed a college's review page */
export function trackCollegeView(collegeName, collegeId) {
  trackEvent('college_view', {
    college_name: collegeName,
    college_id: collegeId,
  });
}

/** User submitted a review */
export function trackReviewSubmit(collegeName, rating) {
  trackEvent('review_submit', {
    college_name: collegeName,
    rating,
  });
}

/** User opened the "Request a College" modal */
export function trackCollegeRequestOpen() {
  trackEvent('college_request_open');
}

/** User submitted a college request */
export function trackCollegeRequestSubmit(collegeName) {
  trackEvent('college_request_submit', { college_name: collegeName });
}

/** User typed in search box */
export function trackSearch(query) {
  if (!query || query.length < 2) return;
  trackEvent('search', { search_term: query });
}

/** User opened the updates panel */
export function trackUpdatesOpen(unreadCount) {
  trackEvent('updates_panel_open', { unread_count: unreadCount });
}
